/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ db: NonNullable<unknown> }} Audio_Description_Export_Automix_Threshold_LabelInputs */

const en_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Threshold (${i?.db} dB)`)
};

const fr_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seuil (${i?.db} dB)`)
};

const de_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schwellenwert (${i?.db} dB)`)
};

const it_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soglia (${i?.db} dB)`)
};

const ru_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пороговое значение (${i?.db} дБ)`)
};

const es_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Umbral (${i?.db} dB)`)
};

const zh_cn2_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`阈值（${i?.db} dB）`)
};

const ja_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`閾値（${i?.db} dB）`)
};

const hi_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सीमा (${i?.db} dB)`)
};

const pt_pt2_audio_description_export_automix_threshold_label = /** @type {(inputs: Audio_Description_Export_Automix_Threshold_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limiar (${i?.db} dB)`)
};

/**
* | output |
* | --- |
* | "Threshold ({db} dB)" |
*
* @param {Audio_Description_Export_Automix_Threshold_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_threshold_label = /** @type {((inputs: Audio_Description_Export_Automix_Threshold_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Threshold_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_threshold_label(inputs)
	if (locale === "de") return de_audio_description_export_automix_threshold_label(inputs)
	if (locale === "it") return it_audio_description_export_automix_threshold_label(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_threshold_label(inputs)
	if (locale === "es") return es_audio_description_export_automix_threshold_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_threshold_label(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_threshold_label(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_threshold_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_threshold_label(inputs)
	return en_audio_description_export_automix_threshold_label(inputs)
});